import { FileProps } from "@hightouch/formkit";
import { FileInput, FileUploadError } from "@hightouch/htui";
import { Controller } from "react-hook-form";
import { SharedProps } from ".";
import { fileToBase64, fileToString } from "src/ui/file/fileUploader";

export const FKFile = ({
  name,
  acceptedFileTypes,
  transformation,
  isDisabled,
}: FileProps & SharedProps) => (
  <Controller
    name={name}
    render={({ field }) => (
      <FileInput
        accept={acceptedFileTypes}
        isDisabled={isDisabled}
        onUpload={async (file) => {
          if (transformation === "base64") {
            const result = await fileToBase64(file);
            field.onChange(result);
          }

          if (transformation === "string") {
            const result = await fileToString(file);
            field.onChange(result);
          }

          if (transformation === "JSONParse") {
            try {
              const result = JSON.parse(await file.text());
              field.onChange(result);
            } catch {
              throw new FileUploadError("Uploaded file is not a valid JSON");
            }
          }

          if (typeof transformation === "function") {
            const result = await transformation(file);
            field.onChange(result);
          }
        }}
      />
    )}
  />
);
